import Handlebars from "handlebars";

const elements = {
    get projectsList() { return document.getElementById('projects-list') },
    get projectDetail() { return document.getElementById('project-detail') },
    get projectDetailContent() { return document.querySelector('.project-detail-content') },
    get projectDetailBackButton() { return document.querySelector('.architect-profile__back-button') },
    get projectDetailLinks() { return document.querySelectorAll('a.project-tile__link') },
    get tabs() { return document.querySelectorAll('.js-tabs-trigger') },
    get projectsTab() { return document.getElementById('tab2') },
    get awardsTilesContainer() { return document.querySelector('#awards .content .tile-grid__grid') },
    get awardsTiles() { return document.getElementsByClassName('award-tile') },
    get awardsLoadMoreButton() { return document.querySelector('#awards .tile-grid__pagination .button') },
    get awardsTab() { return document.querySelector('.js-tabs-trigger[aria-controls="awards"]') },
}

const fetchProjectDetails = async (practiceId, projectId) => {
    const response = await fetch(`/api/practice/${practiceId}/projects/${projectId}`);
    if (!response.ok) {
        throw new Error('Network response was not ok');
    }
    const projectDetails = await response.json();
    return projectDetails;
};

const escapeHtml = (str) => {
    if (!str) return '';
    return str.replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;').replace(/"/g, '&quot;');
};

const buildGalleryHtml = (documents) => {
    if (!documents || documents.length === 0) return '';

    let html = '';

    for (let i = 0; i < documents.length; i++) {
        const pos = i % 4;
        const doc = documents[i];
        const url = escapeHtml(doc.documentUrl);
        const name = escapeHtml(doc.name);
        const desc = escapeHtml(doc.description);

        if (pos === 0) {
            html += `<div class="column-wrapper architect-profile__project-gallery-row">
                <div class="column-1of1">
                    <figure>
                        <a href="${url}" data-fancybox="gallery" data-caption="${desc}">
                            <img src="${url}" width="2800" height="1616" loading="lazy" alt="${name}">
                        </a>
                        <figcaption>${desc}</figcaption>
                    </figure>
                </div>
            </div>`;
        } else if (pos === 1) {
            html += `<div class="column-wrapper architect-profile__project-gallery-row architect-profile__project-gallery-row--2col">
                <div class="column-5of12 column-start-2">
                    <figure>
                        <a href="${url}" data-fancybox="gallery" data-caption="${desc}">
                            <img src="${url}" width="1144" height="1720" loading="lazy" alt="${name}">
                        </a>
                        <figcaption>${desc}</figcaption>
                    </figure>
                </div>`;
            if (i + 1 >= documents.length || (i + 1) % 4 !== 2) {
                html += `</div>`;
            }
        } else if (pos === 2) {
            html += `<div class="column-5of12">
                    <figure>
                        <a href="${url}" data-fancybox="gallery" data-caption="${desc}">
                            <img src="${url}" width="1144" height="1720" loading="lazy" alt="${name}">
                        </a>
                        <figcaption>${desc}</figcaption>
                    </figure>
                </div>
            </div>`;
        } else if (pos === 3) {
            html += `<div class="column-wrapper architect-profile__project-gallery-row">
                <div class="column-1of1">
                    <figure class="full-width-image">
                        <a href="${url}" data-fancybox="gallery" data-caption="${desc}">
                            <img src="${url}" width="2800" height="1144" loading="lazy" alt="${name}">
                        </a>
                        <figcaption>${desc}</figcaption>
                    </figure>
                </div>
            </div>`;
        }
    }
    return html;
};

const renderProjectDetailSection = async (practiceId, projectId) => {
    const projectDetails = await fetchProjectDetails(practiceId, projectId);

    const source = document.getElementById('project-details-template').innerHTML;
    const template = Handlebars.compile(source);
    const html = template(projectDetails);

    elements.projectDetailContent.innerHTML = html;

    const galleryEl = elements.projectDetailContent.querySelector('.architect-profile__project-gallery');
    if (galleryEl && projectDetails.data && projectDetails.data.documents) {
        galleryEl.innerHTML = buildGalleryHtml(projectDetails.data.documents);
    }

    elements.projectDetail.style.display = "block";
    elements.projectsList.style.display = "none";

    requestAnimationFrame(() => {
        window.scrollTo({
            top: 0,
            left: 0,
            behavior: "smooth"
        });
    });
};

const getProjectIdFromUri = (uri) => {
    const href = uri.lastIndexOf('/') === uri.length - 1 ? uri.substr(0, uri.length - 1) : uri
    const projectId = href.split('/').pop()
    return projectId;
};

const getPracticeIdFromUri = (uri) => {
    const href = uri.lastIndexOf('/') === uri.length - 1 ? uri.substr(0, uri.length - 1) : uri
    const practiceId = href.split('/').slice(-4)[0]
    return practiceId;
};


const handleViewProjectDetailLink = (e) => {
    e.preventDefault();

    const link = e.currentTarget;
    const practiceId = getPracticeIdFromUri(link.href);
    const projectId = getProjectIdFromUri(link.href);

    window.history.pushState({}, "", link.href);
    renderProjectDetailSection(practiceId, projectId);
};

const handleBackToProjectsList = (e) => {
    e.preventDefault();

    if (window.location.href.includes('/projects/')) {
        window.history.replaceState({}, '', window.location.href.split('projects/')[0]);
    } else {
        history.back();
    }

    showProjectsList(e);
};

const awardsPaginationConfig = {
    itemsPerPage: 4,
    currentPage: 1,
    totalItems: elements.awardsTiles.length
}
let awardsTiles;

const doAwardsPagination = () => {
    if (elements.awardsTab) {
        if (awardsPaginationConfig.currentPage === 1) {
            awardsTiles = Array.from(elements.awardsTiles);
            elements.awardsTilesContainer.innerHTML = '';

            const firstPageTiles = awardsTiles.slice(awardsPaginationConfig.currentPage - 1, awardsPaginationConfig.itemsPerPage);

            firstPageTiles.forEach(tile => {
                elements.awardsTilesContainer.appendChild(tile);
            });
        } else {
            const nextPageTiles = awardsTiles.slice((awardsPaginationConfig.currentPage - 1) * awardsPaginationConfig.itemsPerPage, awardsPaginationConfig.currentPage * awardsPaginationConfig.itemsPerPage);
            nextPageTiles.forEach(tile => {
                elements.awardsTilesContainer.appendChild(tile);
            });
        }


        if (awardsPaginationConfig.currentPage * awardsPaginationConfig.itemsPerPage >= awardsPaginationConfig.totalItems) {
            elements.awardsLoadMoreButton.style.display = 'none';
        }
    }
};

const showProjectsList = (e) => {
    elements.projectDetail.style.display = "none";
    elements.projectsList.style.display = "block";
};

document.addEventListener("DOMContentLoaded", async () => {

    if (window.location.pathname.includes('/projects/')) {
        elements.projectsTab.click();
        const practiceId = getPracticeIdFromUri(window.location.href);
        const projectId = getProjectIdFromUri(window.location.href);
        window.history.pushState({}, "", window.location.href);
        renderProjectDetailSection(practiceId, projectId);
    }

    if (window.location.hash) {
        const hash = window.location.hash.substr(1);
        const tab = document.querySelector(`.js-tabs-trigger[aria-controls="${hash}"]`);
        if (tab) {
            tab.click();tab.click();
        } else {
            elements.projectsTab.click().click(); // TODO: remove double click whenever NZIA-305 is fixed
        }
    }

    elements.projectDetailLinks?.forEach(x => x.addEventListener('click', handleViewProjectDetailLink));
    elements.projectDetailBackButton?.addEventListener('click', handleBackToProjectsList);

    window.onpopstate = function (e) {
        if (window.location.pathname.includes('/projects/')) {
            elements.projectDetail.style.display = "block";
            elements.projectsList.style.display = "none";
            return;
        }

        showProjectsList(e);
    };

    doAwardsPagination();

    elements.awardsLoadMoreButton?.addEventListener('click', (e) => {
        awardsPaginationConfig.currentPage += 1;
        doAwardsPagination();
    });
});
